import React from 'react'
import ReactPaginate from 'react-paginate'
import { Modal, ModalBody } from 'reactstrap'
import queryString from 'query-string'
import axios from 'axios'
import Select from 'react-select'
import { get, debounce } from 'lodash'
import { toast } from 'react-toastify'
import Loading from '../components/Loading'
import { BaseListStyleButton } from '../pages/encomendas/style'
import { Form } from 'informed'
import { default as FormContainer } from '../containers/Form'
import InputText from '../components/inputs/InputText'
import InputSummernote from '../components/inputs/InputSummernote'
import InputSelect from '../components/inputs/InputSelect'
import { InputCheckbox } from '../components/inputs'
import { API_HOST } from '../consts'
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import {
  Typography,
} from '@material-ui/core';
import { TrackGoogleAnalyticsEvent } from '../utils/googleAnalytics'
import { ClickAllObjects, ClickAllObjectsAction } from '../utils/googleAnalytics/events/Itens/EventAllObjects'

const mapMatrizReferencia = ({ id, nome }) => ({
  value: id,
  label: nome
})
class BaseList extends React.Component {
  state = {
    fetchingData: true,
    page: 1,
    page_size: 5,
    data: [],
    ordering: '-criado_em',
    typeModal: ''
  };

  metadata = {};

  shouldDisplay(field) {
    const { metadata } = this.metadata;
    return get(metadata, field) > 0;
  }

  fetchExame() {
    axios.get(`${API_HOST}/core/exame`).then((res) => {
      this.setState({ exame: res.data })
    })
  };

  fetchExamType() {
    axios.get(`${API_HOST}/avaliacoes/examType`)
      .then((response) => {
        this.setState({
          exam_type: response.data.map((x) => ({
            value: x.id,
            label: x.tipo
          }))
        })
      })
      .catch((response) => console.error(response.error))
  }

  analytcsClick = (name, type) => {
    let label = "Click" + ": " + name;
    let category = ClickAllObjects + "_" + type;

    TrackGoogleAnalyticsEvent(
      category,
      ClickAllObjectsAction,
      label,
    );
  };

  componentDidMount() {
    const { location } = this.props

    const search = queryString.parse(location.search)
    if (search.search) {
      this.search = search.search
    }
    if (search.page) {
      this.setState({ page: search.page }, this.fetchData)
    } else {
      this.fetchData()
    }
  }

  getParams = () => {
    const { page, page_size, ordering } = this.state
    return {
      page,
      page_size,
      search: this.search,
      ordering,
      ...this.params
    }
  };

  maisAntigos = 'criado_em';
  maisRecentes = '-criado_em';
  shouldFetchPermissions = false;
  paginationOptions = [
    { value: '5', label: '5' },
    { value: '10', label: '10' },
    { value: '25', label: '25' },
    { value: '50', label: '50' }
  ];

  hasPermission(name) {
    const permissions = get(this.props, 'permissions') || {}
    // eslint-disable-next-line
    return permissions.__all__ || permissions[name]
  }

  fetchDataCallback() { }

  fetchData = (loading = true, params) => {
    if (loading) {
      this.setState({ fetchingData: true })
    }

    return axios
      .get(this.api, {
        params: params ? params : this.getParams()
      })
      .then((response) => {
        this.setState(
          {
            data: response.data.results,
            total: get(response, 'data.count', '-'),
            total_pages: get(response, 'data.total_pages', 0),
            fetchingData: false
          },
          () => {
            this.fetchDataCallback(response.data.results)
          }
        )
      })
      .catch((error) => {
        const status = get(error, 'response.status')
        if (status === 404) {
          const e = get(error, 'response.data.detail')
          toast.error(e)
        }

        this.setState({ fetchingData: false })
      })
  };

  debouncedFetchData = debounce((search, loading = true) => {
    this.search = search

    this.setState({ page: 1 }, () => this.fetchData(loading))
  }, 500);

  changePage = (pagination) => {
    const { location, history } = this.props
    this.setState({ fetchingData: true })
    const page = pagination.selected + 1
    this.setState({ page }, this.fetchData)
    const search = queryString.stringify({
      ...queryString.parse(location.search),
      page
    })
    history.push(`${location.pathname}?${search}`)
  };

  removeItem = (itens) => {
    this.setState({ removing: true })
    if (itens.length > 1) {
      itens.forEach((id) => {
        axios.delete(`${this.api}/${id}`).then(() => {
          this.setState({ openModal: null })
          // O timeout é para evitar que o usuário veja a mudança de estado
          setTimeout(() => {
            this.setState({ removing: false, selectedForRemovalId: null })
          }, 100)
          toast.success('Removido com sucesso.')
          this.fetchData(false)
        })
      })
    }
    axios.delete(`${this.api}/${itens}`).then(() => {
      this.setState({ openModal: null })
      // O timeout é para evitar que o usuário veja a mudança de estado
      setTimeout(() => {
        this.setState({ removing: false, selectedForRemovalId: null })
      }, 100)
      toast.success('Removido com sucesso.')
      this.fetchData(false)
    })
  };

  handleSubmitCallback(response) { }


  makingTrilha = (itens) => {
    const { nome, nome_docente, categoria, tipo, areasConhecimentoId, componenteCurricularId, codigoId, cursoId, anoId, matrizReferenciaId, habilidadeSearch, valor, numeroAlternativas, instrucoes, atvPublica, anxDocument } = this.state

    const parsedItens = itens.map(item => parseInt(item))

    const dados = {
      nome: nome,
      nome_docente: nome_docente,
      valor: valor,
      exame: categoria,
      instrucoes: instrucoes,
      area_conhecimento: areasConhecimentoId,
      componente_curricular: componenteCurricularId,
      exam_type: tipo,
      curso: [cursoId],
      habilidade: habilidadeSearch,
      matriz_referencia: matrizReferenciaId,
      numero_de_alternativas: numeroAlternativas,
      candidato_anexo_reposta: anxDocument,
      publico: atvPublica,
      periodo: anoId,
      itens: parsedItens,
    }

    Object.keys(dados).forEach((x) => {
      if (dados[x] === '') {
        dados[x] = null
      }
    })
    if (dados.curso === undefined || dados.valor === undefined || dados.nome === undefined) {
      toast.error('Os campos nome, valor e curso são obrigatórios')
    }
    else {
      axios.post(`${API_HOST}/avaliacoes/avaliacao`, dados)
        .then(response => {
          this.handleSubmitCallback(response)
          this.toggleModal()
          toast.success('Avaliação criada com sucesso!')
          window.location.href = `/instrumentos-cognitivos/${response.data.id}/itens`
        })
        .catch(error => {
          console.error(error)
          toast.error('Ocorreu um erro ao criar a avaliação. Por favor, tente novamente.')
        })
    }
  };

  handleInputChange = (event, field) => {
    const value = event
    this.setState((prevState) => ({
      [field]: value,
    }))
  };

  handleSearch = (search) => {
    this.search = search
    this.debouncedFetchData(search, false)
  };

  handleOrderingChange = (value) => {
    this.setState({ ordering: get(value, 'value') }, this.fetchData)
  };

  handleRemove = (id, typeModal) => {
    this.setState({
      selectedForRemovalId: id,
      openModal: 'removeConfirmation',
      typeModal: typeModal
    })
  };

  handleCopy = (id) => {
    const { history } = this.props
    axios
      .post(`${this.api}/${id}/copy`)
      .then((res) => {
        toast.success('Copiado com sucesso.')
        history.push(
          `/instrumentos-cognitivos/${res.data.id}/dados/tipo/3`
        )
      })
      .catch((error) => {
        const status = get(error, 'response.status')
        if (status === 404) {
          const e = get(error, 'response.data.detail')
          toast.error(e)
        } else {
          toast.error('Aconteceu um erro. A cópia não foi efetuada')
        }
      })
  };

  toggleModal = (name) => {
    const { openModal } = this.state
    this.setState({ openModal: openModal === name ? null : name })
  };

  // renderPagination() {
  //   const { page, data, total_pages, fetchingData } = this.state;

  //   if (fetchingData) {
  //     return null;
  //   }

  //   if (data.length > 0) {
  //     return (
  //       <nav style={{ textAlign: 'center' }}>
  //         <ReactPaginate
  //           pageCount={total_pages}
  //           pageRangeDisplayed={3}
  //           marginPagesDisplayed={2}
  //           previousLabel="ANTERIOR"
  //           nextLabel="PRÓXIMA"
  //           onPageChange={this.changePage}
  //           initialSelected={page}
  //           forcePage={page - 1}
  //           containerClassName="pagination"
  //           activeClassName="active"
  //           disabledClassName="disabled"
  //           disableInitialCallback
  //           breakLabel={<button className="disabled">...</button>}
  //         />
  //       </nav>
  //     );
  //   }

  //   return null;
  // }

  handlePageSizeChange = (value) => {
    this.setState(
      {
        page_size: get(value, 'value'),
        page: 1
      },
      this.fetchData
    )
  };

  renderPagination() {
    const { page, data, total_pages, fetchingData, total, page_size } =
      this.state

    if (fetchingData) {
      return null
    }

    if (data.length > 0) {
      return (
        <div className="row" style={{ textAlign: 'center' }}>
          <div className="col-md-3">
            <Select
              matchPos="auto"
              className="filter-size"
              value={page_size}
              options={this.paginationOptions}
              clearable={false}
              onChange={this.handlePageSizeChange}
              searchable={false}
            />
          </div>
          <div className="col-md-3 col-lg-3 col-xs-3" style={{ fontSize: 12 }}>
            <p style={{ marginBottom: 5, marginTop: 10 }}>
              Mostrando <b>{data.length}</b> de <b>{total}</b> registros
            </p>
          </div>
          <div className="col-6">
            <ReactPaginate
              pageCount={total_pages}
              pageRangeDisplayed={2}
              marginPagesDisplayed={2}
              previousLabel="ANTERIOR"
              nextLabel="PRÓXIMA"
              onPageChange={this.changePage}
              initialSelected={page}
              forcePage={page - 1}
              containerClassName="pagination"
              activeClassName="active"
              disabledClassName="disabled"
              disableInitialCallback
              breakLabel={<button className="disabled">...</button>}
            />
          </div>
        </div>
      )
    }

    return null
  }

  renderBreadcrumb() {
    return null
  }

  renderToolbar() {
    return null
  }

  renderList() {
    return null
  }

  renderRemoveConfirmationModal() {
    const { openModal, selectedForRemovalId, removing, typeModal } = this.state
    const isOpen = openModal === 'removeConfirmation'
    const toggleModal = () => this.toggleModal('removeConfirmation')

    return (
      <Modal centered isOpen={isOpen} toggle={toggleModal} size="md">
        <BaseListStyleButton>
          <ModalBody>
            <p className="mt-3 mb-3">
              {this.removeConfirmationMessage(selectedForRemovalId)}
            </p>
            <p>
              Essa ação <strong>não</strong> poderá ser desfeita.
            </p>
            <div className="d-flex justify-content-center">
              <button
                onClick={() => {
                  if (typeModal == 'avaliacao') {
                    this.analytcsClick(`Cancel Delete Avaliação ${selectedForRemovalId}`, 'Avaliação Card');
                  }
                  if (typeModal == 'item') {
                    this.analytcsClick(`Cancel Delete Item ${selectedForRemovalId}`, 'Button: Objects Card');
                  }
                  toggleModal();
                }}
                className="btn-modal-secundary"
                disabled={removing}
              >
                Cancelar
              </button>
              <button
                onClick={() => {
                  if (typeModal == 'avaliacao') {
                    this.analytcsClick(`Delete Avaliação ${selectedForRemovalId}`, 'Avaliação Card');
                  }
                  if (typeModal == 'item') {
                    this.analytcsClick(`Delete Item ${selectedForRemovalId}`, 'Button: Objects Card');
                  }
                  this.removeItem(selectedForRemovalId);
                }}
                className="btn-modal-primary"
                disabled={removing}
              >
                {removing ? 'Removendo...' : 'Confirmar'}
              </button>
            </div>
          </ModalBody>
        </BaseListStyleButton>
      </Modal>
    )
  }

  fetchAreaConhecimento() {
    axios.get(`${API_HOST}/core/area_conhecimento`)
      .then((response) => {
        const data = response.data.results ? response.data.results : response.data
        this.setState({
          area_conhecimento: data.map((x) => ({

            label: x.descricao,
            value: x.id
          }))
        })
      })
      .catch((error) => {
        // Handle any errors here
        console.error('Error fetching area conhecimento:', error)
      })
  }

  fetchComponenteCurricular = (event) => {
    const { areasConhecimentoId } = this.state
    const params = {
      area_conhecimento_id: areasConhecimentoId
    }
    axios
      .get(
        `${API_HOST}/core/componente_curricular`, { params }
      )
      .then((response) => {

        const options = response.data.map((mapResponse) => ({
          value: mapResponse.id,
          label: mapResponse.descricao
        }))
        this.setState({ componenteCurricular: options })
        // callback(null, { options })
      })
  };
  fetchCurso = debounce((input, callback) => {
    axios
      .get(`${API_HOST}/core/curso`, {})
      .then((response) => {
        const options = [];
        response.data.forEach((mapResponse) => {
          if (mapResponse.oculto !== true) {
            options.push({
              value: mapResponse.id,
              label: mapResponse.descricao,
              codigo: mapResponse.codigo
            });
          }
        });
        this.setState({ curso: options })
      })
      .catch((error) => console.error(error))
  }, 1000);
  fetchHabilidade = debounce((input, callback) => {
    const {
      areasConhecimentoId,
      componenteCurricularId,
      anoId,
      matrizReferenciaId,
      habilidadeSearch
    } = this.state

    const params = {
      area_conhecimento_id: areasConhecimentoId,
      matriz_id: matrizReferenciaId,
      etapa_id: anoId,
      disciplina: componenteCurricularId,
      search: habilidadeSearch
    }


    axios
      .get(
        `${API_HOST}/matriz_referencia/habilidade`, { params }
      )
      .then((response) => {
        const options = response.data.results.map((mapResponse) => ({
          value: mapResponse.id,
          label: `${mapResponse.cd_habilidade} - ${mapResponse.ds_habilidade}`
        }))
        this.setState({ habilidades: options })

      })
  }, 600);


  fetchMatrizReferencia = debounce((input, callback) => {
    const { codigoId, areasConhecimentoId } =
      this.state

    const params = {
      status: 1,
      page_size: 100
    }

    if (codigoId) {
      params.curso__id = codigoId
    } else {
      params.curso__id = ''
    }

    if (areasConhecimentoId) {
      params.areas_conhecimento__id = areasConhecimentoId
    } else {
      params.areas_conhecimento__id = ''
    }

    axios
      .get(`${API_HOST}/matriz_referencia/matriz_referencia`, { params })
      .then((response) => {
        const options = response.data.map(mapMatrizReferencia)
        this.setState({ matriz_referencia: options })
        callback(null, { options })
      })
      .catch((error) => console.error(error))
  }, 1000);

  fetchPeriodo = debounce((input, callback) => {
    const { cursoId } = this.state

    if (cursoId) {
      axios
        .get(`${API_HOST}/core/periodo/${cursoId}/filter_curso`)
        .then((response) => {
          const options = []
          response.data.map((mapResponse) => {
            if (mapResponse.etapa_nr && mapResponse.oculto !== true) {
              options.push({
                value: mapResponse.id,
                label: mapResponse.descricao,
              })
            }
          })
          this.setState({ periodo: options })
          callback(null, { options })
        })
        .catch((error) => console.error(error))
    } else {
      axios
        .get(`${API_HOST}/core/periodo`, {})
        .then((response) => {
          const options = response.data.map((mapResponse) => ({
            value: mapResponse.id,
            label: mapResponse.descricao
          }))
          this.setState({ periodo: options })
          callback(null, { options })
        })
        .catch((error) => console.error(error))
    }
  }, 1000);

  renderCriarTrilha() {
    const {
      openModal,
      selectedForRemovalId,
      removing,
      area_conhecimento,
      componenteCurricular,
      curso,
      periodo,
      matriz_referencia,
      habilidades
    } = this.state
    const isOpen = openModal === 'criarTrilha'
    const toggleModal = () => this.toggleModal('criarTrilha')
    const { exame, exam_type } = this.state // Destructure the state variables

    if (!exame || !exam_type) {
      // If data is not fetched yet, fetch it and return null for now
      this.fetchExame()
      this.fetchExamType()
      this.fetchAreaConhecimento()
      this.fetchComponenteCurricular()
      this.fetchCurso()
      return null
    }
    return (
      <Modal centered isOpen={isOpen} toggle={toggleModal} size="lg">
        <BaseListStyleButton>

          <Form
            onChange={(formState) => this.setState({ formState })}
            getApi={(formApi) => {
              this.formApi = formApi
            }}
          >
            {() => {

              return (
                <FormContainer title="Dados">
                  <div className="row">
                    <InputText
                      col="col-sm-9"
                      label="Título da Atividade"
                      field="nome"
                      required={true}
                      onChange={(event) => {
                        this.handleInputChange(event, 'nome')
                      }}

                    />
                    <InputText
                      col="col-sm-3"
                      label="Valor"
                      field="valor"
                      required={true}
                      onChange={(event) => this.handleInputChange(event, 'valor')}
                    />

                    {this.shouldDisplay('avaliacao.categoria') && (            
                      <InputSelect
                        col="col-sm-6"
                        label="Categoria"
                        field="exame"
                        options={this.state.exame.map((i) => (
                          { value: i.id, label: i.descricao }
                        ))}
                        onChange={(event) => this.handleInputChange(event.value, 'categoria')}
                      />
                    )}

                    <InputSelect
                      col="col-sm-6"
                      label="Segmento/Etapa"
                      onChange={(event) =>
                        event
                          ? (this.setState({
                            codigoId: event.codigo,
                            cursoId: event.value
                          }),
                            this.fetchMatrizReferencia(),
                            this.fetchPeriodo(),
                            (event.value==6 && this.state.componenteCurricularId)&&
                              this.setState({
                                componenteCurricularId: '',
                              })
                            
                            )
                            
                          : (this.setState({ codigoId: '', cursoId: '' }),
                            this.fetchMatrizReferencia(),
                            this.fetchPeriodo())
                      }
                      options={curso}
                      field="curso"
                    />

                    <InputSelect
                      col="col-sm-6"
                      label="Série/Ano"
                      required={true}
                      options={periodo}
                      onChange={(event) => event ? (
                        this.setState({ anoId: event.value }),
                        this.fetchHabilidade()
                      ) : (
                        this.setState({ anoId: '' })
                      )}
                      field="periodo"
                    />
                    
                    <InputSelect
                      // multi
                      col="col-sm-6"
                      label="Área do conhecimento"
                      field="area_conhecimento"
                      options={area_conhecimento}
                      onChange={(event) => {
                        const areasConhecimentoId = event.value
                        this.setState({ areasConhecimentoId }, () => {
                          this.fetchComponenteCurricular(event.value)
                        })
                      }}
                    />
                    {this.state.cursoId != 6?
                    <InputSelect
                      col="col-sm-6"
                      label="Componente curricular"
                      field="componente_curricular"
                      required={true}
                      onChange={(event) =>
                        event
                          ? (this.setState({ componenteCurricularId: event.value }),
                            this.fetchHabilidade())
                          : (this.setState({ componenteCurricularId: '' }),
                            this.fetchHabilidade())
                      }
                      options={componenteCurricular}

                    />
                    :
                    <>
                    </>
                    }


                    {this.shouldDisplay('avaliacao.matriz_referencia') && (
                      <InputSelect
                        col="col-sm-12"
                        label="Matriz de referência"
                        field='matriz_referencia'
                        options={matriz_referencia}
                        onChange={(event) => event ? (
                          this.setState({ matrizReferenciaId: event.value }),
                          this.fetchHabilidade()
                        ) : (
                          this.setState({ matrizReferenciaId: '' }),
                          this.fetchHabilidade()
                        )}
                      />
                    )}

                    {this.shouldDisplay('avaliacao.habilidade') && (
                      <InputSelect
                        col="col-sm-12"
                        label="Habilidade"
                        field="habilidade"
                        required={true}
                        options={habilidades}
                        onChange={(event) => {
                          if (!event) {
                            this.setState({ habilidadeSearch: '' })
                          }
                          this.setState({ habilidadeSearch: event.value })
                        }}
                      />
                    )}

                    <React.Fragment>
                      {this.hasAlternativas ? (
                        <InputText
                          col="col-sm-3"
                          label="Número de Alternativas"
                          field="numero_de_alternativas"
                          onChange={(event) => this.handleInputChange(event.values, 'numeroAlternativas')}
                        />
                      ) : null}
                    </React.Fragment>
                    <InputSummernote
                      col="col-sm-12"
                      label="Instruções"
                      field="instrucoes"
                      onChange={(event) => this.handleInputChange(event, 'instrucoes')}
                    />
                  </div>
                  {this.shouldDisplay('avaliacao.publico') && (
                    <InputCheckbox
                      col="col-md-12 mb-3"
                      field="publico"
                      label="Tornar atividade pública?"
                      onChange={(event) => {
                        const isChecked = event.target.checked
                        this.handleInputChange(isChecked, 'atvPublica')
                      }}
                    />
                  )}

                  {this.shouldDisplay('avaliacao.anexar_como_resposta') && (
                    <InputCheckbox
                      col="col-md-12 mb-3"
                      field="candidato_anexo_reposta"
                      label="Candidato pode anexar documento como resposta."
                      onChange={(event) => {
                        const isChecked = event.target.checked
                        this.handleInputChange(isChecked, 'anxDocument')
                      }}
                    />
                  )}
                  <p className="mt-3 mb-3">
                    {this.criarTrilhaMessage(selectedForRemovalId)}
                  </p>

                  <div className="d-flex justify-content-center">
                    <button
                      onClick={toggleModal}
                      className="btn-modal-secundary"
                    >
                      Cancelar
                    </button>
                    <button
                      onClick={() => this.makingTrilha(selectedForRemovalId)}
                      className="btn-modal-primary"
                    >
                      Confirmar
                    </button>
                  </div>
                </FormContainer>
              )
            }}
          </Form>
        </BaseListStyleButton>
      </Modal>
    )
  }

  renderOrderingSelect() {
    const { ordering } = this.state
    return (
      <div className="ml-2">
        <UncontrolledDropdown>
          <DropdownToggle
            onClick={() => { this.analytcsClick('Ordenar', 'Button: Ordenar') }}
            style={{
              width: '122px',
              height: '40px',
              padding: '8px 16px',
              background: "#E4E4E4",
              borderRadius: "24px",
              border: "none",
              outline: "none",
              textTransform: "capitalize",
              display: 'flex',
              alignItems: 'center'
            }} >
            <Typography
              style={{
                fontFamily: 'Public Sans',
                fontSize: '16px',
                fontWeight: 700,
                lineheight: '24px',
                letterSpacing: '0em',
                textAlign: 'center',
                color: "#383838",
                display: 'flex',
                alignItems: 'center'
              }}
            >
              Ordenar
              <i style={{ marginLeft: '5px', color: "#383838", fontSize: '30px' }} className="icon-Arrow-tip-down" />
            </Typography>
          </DropdownToggle>
          <DropdownMenu style={{
            fontFamily: 'Public Sans',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '19px',
            letterSpacing: '0em',
            textAlign: 'left'
          }}>

            <DropdownItem onClick={() => {
              this.analytcsClick('Ordenar: Mais recente', 'Button: Ordenar');
              this.handleOrderingChange({
                value: this.maisRecentes,
                label: 'Mais Recentes'
              })
            }}>Mais recente</DropdownItem>
            <DropdownItem onClick={() => {
              this.analytcsClick('Ordenar: Mais antigo', 'Button: Ordenar');
              this.handleOrderingChange({
                value: this.maisAntigos,
                label: 'Mais Antigos'
              });
            }}>Mais antigo</DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    )
  }

  render() {
    const { fetchingData } = this.state

    return (
      <div>
        {this.renderBreadcrumb()}
        <div className="container pb-5">
          {this.renderToolbar()}
          {fetchingData ? <Loading /> : this.renderList()}
          {this.renderPagination()}
        </div>
        {this.renderRemoveConfirmationModal()}

      </div>
    )
  }
}

export default BaseList
